import React from 'react';
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>{t('services.title')}</h1>
          <p>{t('services.subtitle')}</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          {/* Web Development */}
          <div className="content-section">
            <h2>{t('services.web_development.title')}</h2>
            <p>{t('services.web_development.description')}</p>
            
            <h3>{t('services.web_development.what_we_offer')}</h3>
            <ul>
              {(t('services.web_development.services', { returnObjects: true }) || []).map((service, index) => (
                <li key={index}><strong>{service.split(':')[0]}:</strong> {service.split(':').slice(1).join(':')}</li>
              ))}
            </ul>

            <h3>{t('services.web_development.technologies')}</h3>
            <p>{t('services.web_development.tech_list')}</p>
          </div>

          {/* Mobile Development */}
          <div className="content-section">
            <h2>{t('services.mobile_development.title')}</h2>
            <p>{t('services.mobile_development.description')}</p>
            
            <h3>{t('services.mobile_development.what_we_offer')}</h3>
            <ul>
              {(t('services.mobile_development.services', { returnObjects: true }) || []).map((service, index) => (
                <li key={index}><strong>{service.split(':')[0]}:</strong> {service.split(':').slice(1).join(':')}</li>
              ))}
            </ul>

            <h3>{t('services.mobile_development.technologies')}</h3>
            <p>{t('services.mobile_development.tech_list')}</p>
          </div>

          {/* Community Management */}
          <div className="content-section">
            <h2>{t('services.community_management.title')}</h2>
            <p>{t('services.community_management.description')}</p>
            
            <h3>{t('services.community_management.what_we_offer')}</h3>
            <ul>
              {(t('services.community_management.services', { returnObjects: true }) || []).map((service, index) => (
                <li key={index}><strong>{service.split(':')[0]}:</strong> {service.split(':').slice(1).join(':')}</li>
              ))}
            </ul>

            <h3>{t('services.community_management.platforms')}</h3>
            <p>{t('services.community_management.platform_list')}</p>
          </div>

          {/* Game Customization */}
          <div className="content-section">
            <h2>{t('services.game_customization.title')}</h2>
            <p>{t('services.game_customization.description')}</p>
            
            <h3>{t('services.game_customization.what_we_offer')}</h3>
            <ul>
              {(t('services.game_customization.services', { returnObjects: true }) || []).map((service, index) => (
                <li key={index}><strong>{service.split(':')[0]}:</strong> {service.split(':').slice(1).join(':')}</li>
              ))}
            </ul>

            <h3>{t('services.game_customization.games')}</h3>
            <p>{t('services.game_customization.games_list')}</p>
          </div>

          {/* Process */}
          <div className="content-section">
            <h2>{t('services.process.title')}</h2>
            <h3>{t('services.process.step1.title')}</h3>
            <p>{t('services.process.step1.description')}</p>
            
            <h3>{t('services.process.step2.title')}</h3>
            <p>{t('services.process.step2.description')}</p>
            
            <h3>{t('services.process.step3.title')}</h3>
            <p>{t('services.process.step3.description')}</p>
            
            <h3>{t('services.process.step4.title')}</h3>
            <p>{t('services.process.step4.description')}</p>
            
            <h3>{t('services.process.step5.title')}</h3>
            <p>{t('services.process.step5.description')}</p>
          </div>

          {/* Pricing */}
          <div className="content-section">
            <h2>{t('services.pricing.title')}</h2>
            <p>{t('services.pricing.description')}</p>
            
            <ul>
              {(t('services.pricing.options', { returnObjects: true }) || []).map((option, index) => (
                <li key={index}><strong>{option.split(':')[0]}:</strong> {option.split(':').slice(1).join(':')}</li>
              ))}
            </ul>
            
            <p>{t('services.pricing.contact')}</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;